import React from 'react';

import PropTypes from 'prop-types';
import { Box, StackView, Typography } from '@telus-uds/components-web';

import {
  Thead,
  Td,
  Tr,
  Th
} from '../orderDetailsSection/ratePlans/components/css';
import getFormattedPricing from '../orderDetailsSection/utils';

const SummaryOrderNow = ({ orderNow, total }) => {
  // Filter out zero-qty entries at render time. Raw map is still
  // persisted to BE (partial-merge save needs explicit qty:0 to clear
  // previously-saved entries); the in-app summary should only show
  // entries the customer actually selected.
  const visibleOrderNow = Object.keys(orderNow).filter(
    item => orderNow[item] && Number(orderNow[item].quantity) > 0
  );
  if (visibleOrderNow.length === 0) return null;
  return (
    <>
      {Object.keys(orderNow).length > 0 && (
        <StackView space={3}>
          <Typography heading="h4" variant={{ size: 'h4' }} block>Order Now</Typography>
          <table>
            <Thead>
              <Tr>
                <Th>Partner</Th>
                <Th>Quantity</Th>
                <Th>Unit Price</Th>
                <Th>Total monthly fee</Th>
              </Tr>
            </Thead>
            <tbody>
              {visibleOrderNow.map(addonName => {
                const { quantity, unitPrice } = orderNow[addonName];
                return (
                  <tr>
                    <Td style={{ background: '#f7f7f7', fontWeight: '700' }}>
                      {addonName}
                    </Td>
                    <Td>{quantity}</Td>
                    <Td>{getFormattedPricing(unitPrice)}</Td>
                    <Td>{getFormattedPricing(unitPrice * quantity)}</Td>
                  </tr>
                );
              })}
              <Tr style={{ background: '#f4f4f4' }}>
                <Td colSpan={3}>
                  <Typography variant={{ bold: true }}>Total</Typography>
                </Td>
                <Td>
                  <Typography variant={{ bold: true }}>{getFormattedPricing(total)}</Typography>
                </Td>
              </Tr>
            </tbody>
          </table>
        </StackView>
      )}
    </>
  );
};

SummaryOrderNow.propTypes = {
  orderNow: PropTypes.shape({
    quantity: PropTypes.number,
    unitPrice: PropTypes.number
  }).isRequired,
  total: PropTypes.number.isRequired
};

export default SummaryOrderNow;
